import React from 'react';
import {useCookies} from 'react-cookie';
import semver from 'semver';
import feat130 from '../assets/feat_1_3_0-expense_list.png';
import feat140List from '../assets/feat_1_4_0-expense_list.png';
import feat140Entry from '../assets/feat_1_4_0-expense_entry.gif';
import feat150ExpenseAccount from '../assets/feat_1_5_0-expense-account-selection.png';
import feat150Profile from '../assets/feat_1_5_0-profile.png';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper
} from '@mui/material';
const releases = [{
  version: '1.3.0',
  content: <div key="1.3.0">
    <h4>Multi-currency expenses: USD+LBP</h4>
    <Paper elevation={5} className="img-wrapper">
      <img src={feat130} style={{width: '100%'}} alt="Multi-currency expense item" />
    </Paper>
    <div style={{marginBlockStart: '1rem'}}>
      Select the "USD+LBP" option when adding an expense and you will be able to enter
      values for both currencies. Useful in those situations where you pay mostly in
      dollars but need to pay the small change in LBP.
    </div>
  </div>
}, {
  version: '1.4.0',
  content: <div key="1.4.0">
    <h4>Income Transactions</h4>
    <Paper elevation={5} className="img-wrapper">
      <img src={feat140List} style={{width: '100%'}} alt="Income transaction items" />
    </Paper>
    <div style={{marginBlockStart: '1rem'}}>
      You can now enter transactions for income - or receiving money. Useful when
      someone pays you back or if you pay in dollars and get change in LBP.
    </div>
    <Paper elevation={5} className="img-wrapper">
      <img src={feat140Entry} style={{width: '100%'}} alt="Income transaction entry" />
    </Paper>
    </div>
}, {
  version: '1.5.2',
  content: <div key="1.5.2">
    <h4>Multiple Accounts</h4>
    <Paper elevation={5} className="img-wrapper">
      <img src={feat150ExpenseAccount} style={{width: '100%'}} alt="Expense account selection" />
    </Paper>
    <div style={{marginBlockStart: '1rem'}}>
      You can now select the account for an expense. All non-cash accounts will
      bypass the count of cash remaining from exchanges.
    </div>
    <Paper elevation={5} className="img-wrapper">
      <img src={feat150Profile} style={{width: '100%'}} alt="Profile page with accounts" />
    </Paper>
    <div style={{marginBlockStart: '1rem'}}>
      Manage your accounts and categories from the profile page.
    </div>
    </div>
}];

export default function FeatureAnnouncementWrapper() {
  const [cookies, setCookie] = useCookies(['versionNotice']);

  const setVersionNotice = (version) => {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365); // add 1 year

    setCookie('versionNotice', version || import.meta.env.VITE_VERSION, {
      path: '/',
      expires,
    });
  };

  return <FeatureAnnouncement versionCookie={cookies.versionNotice} setCookie={setVersionNotice} />;
}


export function FeatureAnnouncement({ versionCookie, setCookie }) {
  let shouldBeOpen = false;
  let releasesToNotify = null;

  // if (versionNotice === '0' || semver.lt(versionNotice, '1.3.0')) {
  //   shouldBeOpen = true;
  // }

  // bump expiration into future on every load so it doesn't expire
  if (versionCookie) {
    console.log('loading ' + versionCookie);

    // find new release notices since the last one the user saw
    const versionNotice = versionCookie || '1.0.0';
    console.log('version notice: ' + versionNotice);
    releasesToNotify = releases
      .filter((r) => semver.lt(versionNotice, r.version))
      .map(x => x.content);

    // only notify if there was a previous cookie
    shouldBeOpen = releasesToNotify.length > 0;
  }

  const [open, setOpen] = React.useState(shouldBeOpen);

  const handleClose = () => {
    setOpen(false);
    setCookie(import.meta.env.VITE_VERSION);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        onBackdropClick={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          🚀 New Features 💥
        </DialogTitle>
        <DialogContent>
          {releasesToNotify}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Got it!
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
